const state = {
  notifications: [],
  notification_queue: [],
  notification: false,
  lastNotification: null,
  darkTheme: !!JSON.parse(localStorage.getItem('dark_theme'))
}

const getters = {
  errors: state => state.errors,
  getNotification: state => state.lastNotification,
  hasNotifications: state => (state.notification_queue.length > 0),
  showNotification: state => state.notification,
  darkTheme: state => state.darkTheme
}

const actions = {
  addError: ({ commit }, errorText) => {
    commit('addNotification', {
      type: 'error',
      text: errorText
    })
  },
  addInfo: ({ commit }, message) => {
    commit('addNotification', {
      type: 'info',
      text: message
    })
  },
  addSuccess: ({ commit }, message) => {
    commit('addNotification', {
      type: 'success',
      text: message
    })
  },
  setDarkTheme: ({ commit }, value) => {
    commit('setDarkTheme', value)
  }
}

const mutations = {
  addNotification: (state, notification) => {
    state.notifications.push(notification)
    state.notification_queue.push(notification)

    if (!state.notification) {
      state.lastNotification = state.notification_queue.shift()
      state.notification = true
    }
  },
  setLastNotification: (state) => {
    state.lastNotification = state.notification_queue.shift()
  },
  showNotification: (state) => {
    state.notification = true
  },
  hideNotification: (state) => {
    state.notification = false
  },
  setDarkTheme: (state, value) => {
    state.darkTheme = value

    localStorage.setItem('dark_theme', value)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
